export enum SessionStorageKey {
  AGENCY_DATA_EXT = 'agencyDataExt',
  AGENCY_DATA_FULL = 'agencyDataFull',
  AGENCY_DATA = 'agencyData',
  GROUP_LIST = 'groupList',
  OCCUPANCY_SELECTED = 'occupancySelected',
  USER_DATA = "userData",
  ISO_CODE = "IsoCode",
  BOOKING_LIST_BY_ADV = "BOOKING_LIST_BY_ADV",
  BOOKING_LIST_BY_ADV_OPT = "BOOKING_LIST_BY_ADV_OPT",
  BOOKING_LIST_BY_ADV_BKD = "BOOKING_LIST_BY_ADV_BKD",
  LOYALTY_PROGRAM = 'cckLoyaltyProgram',
  LOYALTY_PROGRAM_NUMBER = 'cckLoyaltyProgramNumber',
  TRAVEL_AGENCY_PROFILE = 'agencyDataFull',
  COUNTRIES = 'cckCountries',
  IS_SUB_AGENTS_VIEW_ACTIVE = 'isSubAgentsViewActive',
  // FUN26 - Configurazione passeggeri dall'engine
  PAX_AGES = 'paxAges',
  CABINS_COUNT = 'cabinsCount',
  CABIN_CONFIG = 'cabinConfig',
  MVP_SELECTED_VERSION = 'mvpSelectedVersion',
  MVP_SELECTED_VARIANT = 'mvpSelectedVariant',
  MVP_SELECTED_MOCK = 'mvpSelectedMock',
}
